import { DefaultPdClientType, Domain } from "../../config";
export const AuthConfig = {
  BaseUrl: `https://api.auth.${Domain}`,
  PdClientId: "authapp",
  PdClientType: DefaultPdClientType
};
